import { useNavigate } from 'react-router-dom';
import { ButtonTransferCompany } from './styleGuide';
import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';

export const BtnTransfer = ({ text, onClick, callComponent }: any) => {
  const navigate = useNavigate();
  const { border } = useAppSelector((state: RootState) => state.styleGuide.data);

  const borderColor = border.primary;
  const borderColorHover = border.hover;

  if (callComponent) navigate('/company-transfer');

  return (
    <div>
      <ButtonTransferCompany $borderColor={borderColor} $borderColorHover={borderColorHover} onClick={onClick}>
        {text}
      </ButtonTransferCompany>
    </div>
  );
};
